// extracted by mini-css-extract-plugin
module.exports = {"tab":"tabsContainer_tab__Hl0wa","list":"tabsContainer_list__PzZKV"};